/**
 * Micro Degree Exam API
 * @author sohyun.ahn@emcast.com
 */
import httpService from "@/api/httpService";

const microExamApi = {
  /**
   * 시험 인트로(get exam intro information)
   * @param params
   * @returns {Promise<unknown>}
   */
  examIntro(params) {
    return httpService.get(
      `/micro/exam/examinee/${params.examineeId}/intro`,
      params
    );
  },

  /**
   * 시험 시작(set exam start)
   * @param params
   * @returns {Promise<unknown>}
   */
  start(params) {
    return httpService.post(`/micro/exam/examinee/${params.examineeId}/start`);
  },

  /**
   * 시험지 정보(get exam information)
   * @param params
   * @returns {Promise<unknown>}
   */
  window(params) {
    return httpService.get(`/micro/exam/examinee/${params.examineeId}/window`);
  },

  /**
   * 시험 문항정보(get exam question groups information)
   * @param params
   * @returns {Promise<unknown>}
   */
  groups(params) {
    return httpService.get(`/micro/exam/examinee/${params.examineeId}/groups`);
  },

  /**
   * 시험지 제출(submit exam)
   * @param params
   * @returns {Promise<unknown>}
   */
  submit(params) {
    return httpService.put(
      `/micro/exam/examinee/${params.examineeId}/submit`,
      params.answers
    );
  },

  /**
   * 제출된 시험지 목록(get submited exam list)
   * @param params
   * @returns {Promise<unknown>}
   */
  submitedList(params) {
    return httpService.get(`/micro/exam/examinee/${params.examineeId}/result`);
  },

  /**
   * 시험 결과(get exam result)
   * @param params
   * @returns {Promise<unknown>}
   */
  result(params) {
    return httpService.get(
      `/micro/exam/examinee/${params.examineeId}/result/${params.paperId}`
    );
  },

  /**
   * 시험 점수 정보(get exam score information)
   * @param params
   * @returns {Promise<unknown>}
   */
  score(params) {
    return httpService.get(
      `/micro/exam/examinee/${params.examineeId}/result/score`
    );
  },

  /**
   * 시험 뱃지(get exam badges list)
   * @param params
   * @returns {Promise<unknown>}
   */
  badges(params) {
    return httpService.get(
      `/micro/exam/examinee/${params.examineeId}/badges`,
      params
    );
  },

  /**
   * 응시여부 확인(check submited exam)
   * @param params
   * @returns {Promise<unknown>}
   */
  dynamic(params) {
    return httpService.get(
      `/micro/exam/independent/${params.distId}/exists/examinee`
    );
  },

  /**
   * 문항 이의제기(regist question issue)
   * @param params
   * @returns {Promise<unknown>}
   */
  issue(params) {
    return httpService.post(
      `/micro/exam/question/${params.questionId}/issue`,
      params
    );
  },

  /**
   * 단독 시험 목록(get independent Exam list)
   * @param params
   * @returns {Promise<unknown>}
   */
  independentExamineeExamList(params) {
    return httpService.get(`/micro/exam/examinee`, params);
  },

  /**
   * 단독 시험응시자 상세(get independent exam examinee view)
   * @param params
   * @returns {Promise<unknown>}
   */
  independentExamineeExamView(params) {
    return httpService.get(`/micro/exam/examinee/${params.examineeId}`, params);
  },

  /**
   * 단독 시험 상세(get independent exam detail)
   * @param params
   * @returns {Promise<unknown>}
   */
  independentExamView(params) {
    return httpService.get(`/micro/exam/independent/${params.distId}`, params);
  },

  /**
   * 게스트 단독시험 목록(get independent exam list for guest)
   * @param params
   * @returns {Promise<unknown>}
   */
  guestExamOnlineList(params) {
    return httpService.get(`/micro/exam/independent`, params);
  },

  /**
   * 게스트 단독시험 갯수(get independent exam count for guest)
   * @param params
   * @returns {Promise<unknown>}
   */
  guestExamOnlineCount(params) {
    return httpService.get(`/micro/exam/independent/count`, params);
  },

  /**
   * 게스트 단독시험 카테고리별 목록(get category independent exam list for guest)
   * @param params
   * @returns {Promise<unknown>}
   */
  guestExamOnlineCategoryList(params) {
    return httpService.get(`/micro/exam/independent/categorization`, params);
  },

  /**
   * 게스트 단독시험 상세(get independent exam detail for guest)
   * @param params
   * @returns {Promise<unknown>}
   */
  guestExamOnlineView(params) {
    return httpService.get(`/micro/exam/independent/${params.distId}`, params);
  },

  /**
   * 게스트 단독시험 배지(get independent exam badges list for guest)
   * @param params
   * @returns {Promise<unknown>}
   */
  guestExamOnlineViewBadges(params) {
    return httpService.get(
      `/micro/exam/independent/${params.distId}/badges`,
      params
    );
  },

  /**
   * 단독 시험 카운트를 조회 (my test count)
   * @param params
   * @returns {Promise<unknown>}
   */
  myExamCount(params) {
    return httpService.get(`/micro/exam/examinee/count`, params);
  },

  /**
   * 시험 문항 이슈 목록 조회(Check list of test questions)
   * @param params
   * @returns {Promise<unknown>}
   */
  myExamIssueList(params) {
    return httpService.get(`/micro/exam/question/issue`, params);
  },

  /**
   * 시험 문항 이슈 상세 조회(Detailed inquiry of test questions)
   * @param params
   * @returns {Promise<unknown>}
   */
  examIssueDetail(params) {
    return httpService.get(
      `/micro/exam/question/issue/${params.issueId}`,
      params
    );
  }
};

export default microExamApi;
